export default __webpack_public_path__ + "static/media/bgBlue50x70.bd5419c9.jpg";